import { render, staticRenderFns } from "./HoribaGetComponent.vue?vue&type=template&id=78e5e9f2"
import script from "./HoribaGetComponent.vue?vue&type=script&lang=js"
export * from "./HoribaGetComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports